import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { remedialWallTiesLp } from "@/content/landing/remedial-wall-ties";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";
import { withServiceLcpPreload } from "@/lib/service-lcp-preload";
import { SERVICE_PAGE_OG_IMAGES } from "@/lib/service-page-og-images";

const LpRemedialWallTiesPage = lazyNamed(
  () => import("@/components/landing/lp-remedial-wall-ties"),
  "LpRemedialWallTies",
);

const PATH = "/remedial-wall-ties";
const TITLE =
  "Remedial Wall Ties South Wales | Structural Survey | CRS Energy";
const DESCRIPTION =
  "Remedial wall tie replacement across South Wales. Borescope cavity inspection, structural assessment, tested CE-marked tie systems, fully insured, insurance-backed guarantee.";

export const Route = createFileRoute("/remedial-wall-ties")({
  head: () =>
    withServiceLcpPreload(PATH, {
    ...pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      image: SERVICE_PAGE_OG_IMAGES[PATH],
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: "Remedial Wall Ties",
        description: DESCRIPTION,
        serviceType: "Remedial Wall Ties",
        url: `${SITE.url}${PATH}`,
        image: SERVICE_PAGE_OG_IMAGES[PATH],
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: remedialWallTiesLp.faqs.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
    ],
  }),
  component: LpRemedialWallTiesPage,
});
